import api from "../index";

export const GetAllAccountApi = (params) => api.get(`Admin/GetAll-MT5LiveAccount?${params}`);
export const MT5RequestAcceptRejectApi = (data) => api.post('Admin/MT5LiveAcc-RejectedApproved', data);
export const GetAllMT5ByIdApi = (MT5Id) => api.get(`MTFiveAccount/UserGetSingle-LiveAccount/${MT5Id}`);
export const GetAllOnlineUsersApi = (params) => api.get(`Admin/Get-Online-User-Detail?${params}`);
export const GetAllInactiveAccounts = (params) => api.get(`Admin/Get-InActive-User-Detail?${params}`);